import { Binary } from "./binary.js";
import { logger } from "./log.js";
const log = logger("LightingData");
export function worldLights(bytes) {
    const r = new Binary(bytes);
    if (bytes.length % 88 || bytes.length / 88 > 8192) throw new Error("Invalid world-light lump");
    const lights = [];
    for (let offset = 0; offset < bytes.length; offset += 88) lights.push({
        origin: r.vec(offset), color: r.vec(offset + 12), normal: r.vec(offset + 24),
        cluster: r.i32(offset + 36), type: r.i32(offset + 40), style: r.i32(offset + 44),
        inner: r.f32(offset + 48), outer: r.f32(offset + 52), exponent: r.f32(offset + 56), radius: r.f32(offset + 60),
        attenuation: r.vec(offset + 64), flags: r.i32(offset + 76),
    });
    log.info("world lights decoded", { count: lights.length, types: [...new Set(lights.map(l => l.type))] });
    return lights;
}
export function vertexLighting(bytes) {
    const r = new Binary(bytes), count = r.i32(20), size = r.u32(12);
    if (r.i32(0) !== 2 || size !== 4 || count < 0 || count > 10000 || r.u32(16) > 2000000)
        throw new Error("Unsupported VHV vertex lighting");
    r.check(40, count * 28);
    const meshes = [];
    let total = 0;
    for (let i = 0; i < count; i++) {
        const o = 40 + i * 28, vertices = r.u32(o + 4), offset = r.u32(o + 8);
        total += vertices;
        if (total > 2000000) throw new Error("VHV exceeds vertex budget");
        r.check(offset, vertices * size);
        if (r.u32(o) !== 0) continue;
        const colors = new Float32Array(vertices * 3);
        for (let vertex = 0; vertex < vertices; vertex++)
            for (let c = 0; c < 3; c++)
                // VHV stores gamma encoded BGR vertex light, not RGBExp pixels.
                colors[vertex * 3 + c] = (2 * r.u8(offset + vertex * 4 + 2 - c) / 255) ** 2.2;
        meshes.push(colors);
    }
    if (total !== r.u32(16)) throw new Error("VHV vertex count differs from header");
    log.debug("baked prop lighting decoded", { checksum: r.u32(4), meshes: meshes.length, vertices: total });
    return { checksum: r.u32(4), meshes };
}
